export default __webpack_public_path__ + "locales/es/Common.json?hash=fe034b77dfc71d3bce15b8a611885b7d";